import { useEffect, useRef, useState } from "react"
import * as myconst from "../../constants"
import { toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";
import { handleLoader } from "redux/counterSlice";
import { useDispatch, useSelector } from "react-redux";
import { compareImages, similarityImages } from "services/lensService";
import { uploadImage } from 'assets/icons';
import { ImageInfo } from 'assets/icons';
import { CompareImageUpload } from 'assets/icons';
import { setImageCompRadio, setNewImage } from "redux/lensSlice";

const fontSizeList = [
    { name: "3" },
    { name: "4" },
    { name: "5" },
    { name: "6" },
    { name: "7" },
    { name: "8" },
    { name: "9" },
    { name: "10" }
]

const similarityList = [
    { name: "similarity search and object detection", code: 0 },
    { name: "Similarity search", code: 1 },
    { name: "object detection", code: 2 }
]

const CompareImage = () => {
    const { control, handleSubmit, setValue, reset, setError, formState: { errors }, clearErrors } = useForm();
    const dispatch = useDispatch();
    const goldImgRef: any = useRef(null);
    const influImgRef: any = useRef(null);
    const [goldenImage, setGoldenImage] = useState("");
    const [goldenImageFile, setGoldenImageFile] = useState<any>("");
    const [influenceImage, setInfluenceImage] = useState("");
    const [gridWidth, setGridWidth] = useState({ name: '3' });
    const [gridHeight, setGridHeight] = useState({ name: '5' });
    const [influenceImageFile, setInfluenceImageFile] = useState<any>("");
    const newImage = useSelector((state: any) => state.lens.newImage);
    const imageCompRadio = useSelector((state: any) => state.lens.imageCompRadio);

    const handleChangeBaseImg = (e: any) => {
        const file = e.target?.files[0];
        if (file) {
            handleFileBase(file);
        }
    };

    const handleDropBase = (e: any) => {
        e.preventDefault();
        const file = e.dataTransfer?.files[0];
        if (file) {
            handleFileBase(file);
        }
    };

    const handleFileBase = async (file: any) => {
        if (!file || !(file instanceof File) || !file.type || !file.size) {
            console.error("Invalid file object or missing properties");
            return;
        }

        const allowedImageTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!allowedImageTypes.includes(file.type)) {
            toast.error("File is not supported", {
                style: { backgroundColor: '#F1F1F1' }
            });
            goldImgRef.current.value = "";
            return;
        }

        const MAX_FILE_SIZE = 5 * 1024 * 1024;
        if (file.size > MAX_FILE_SIZE) {
            toast.error("File size should not be more than 5 MB", {
                style: { backgroundColor: '#F1F1F1' }
            });
            goldImgRef.current.value = "";
            return;
        }
        if (file) {
            if (myconst.imageTypes.includes(file.type)) {
                const base64Code: any = await myconst.fileToBase64(file)
                const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                setGoldenImage(correctBase64);
                setGoldenImageFile(file)
                clearErrors('fileUpload')
            } else {
                toast.error("File is not supported", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                goldImgRef.current.value = ""
            }
        }
    }

    const handleChangeInfulenceImg = (e: any) => {
        const file = e.target?.files[0];
        if (file) {
            handleFileInfluence(file);
        }
    };

    const handleDropInfluence = (e: any) => {
        e.preventDefault();
        const file = e.dataTransfer?.files[0];
        if (file) {
            handleFileInfluence(file);
        }
    };

    const handleFileInfluence = async (file: any) => {
        if (!file || !(file instanceof File) || !file.type || !file.size) {
            console.error("Invalid file object or missing properties");
            return;
        }

        const allowedImageTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!allowedImageTypes.includes(file.type)) {
            toast.error("File is not supported", {
                style: { backgroundColor: '#F1F1F1' }
            });
            influImgRef.current.value = "";
            return;
        }

        const MAX_FILE_SIZE = 5 * 1024 * 1024;
        if (file.size > MAX_FILE_SIZE) {
            toast.error("File size should not be more than 5 MB", {
                style: { backgroundColor: '#F1F1F1' }
            });
            influImgRef.current.value = "";
            return;
        }
        if (file) {
            if (myconst.imageTypes.includes(file.type)) {
                const base64Code: any = await myconst.fileToBase64(file)
                const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                setInfluenceImage(correctBase64);
                setInfluenceImageFile(file)
                clearErrors('inferenceImage')
            } else {
                toast.error("File is not supported", {
                    style: {
                        backgroundColor: '#F1F1F1',
                    }
                })
                influImgRef.current.value = ""
            }
        }
    }

    const onSubmit = async (data: any) => {
        let hasError = false;
        if (goldenImageFile === "") {
            setError('fileUpload', { type: 'custom', message: "Please select base image" });
            hasError = true;
        }
        if (influenceImageFile === "") {
            setError('inferenceImage', { type: 'custom', message: "Please select inference image" });
            hasError = true;
        }
        if (hasError) {
            return;
        }
        if (imageCompRadio === "grid") {
            console.log("data", data)
            data.base_image = goldenImageFile
            data.inference_image = influenceImageFile
            data.grid_width = Number(gridWidth.name)
            data.grid_height = Number(gridHeight.name)
            dispatch(handleLoader(true));
            try {
                const { result, error } = await compareImages(data);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                const img = `https://mgronlenseapi.rysun.in/opt/ronlens/${result.CompareImageGridResult.output_image_path}`
                setInfluenceImage(img)
                setTimeout(() => {
                    dispatch(handleLoader(false));
                }, 1000)
            } catch (error: any) {
                dispatch(handleLoader(false));
            }
        } else {
            data.original_image = goldenImageFile
            data.uploaded_image = influenceImageFile
            data.metadata = "test"
            data.request_type = 2
            dispatch(handleLoader(true));
            try {
                const { result, error } = await similarityImages(data);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                const img = `https://mgronlenseapi.rysun.in/opt/ronlens/${result.Missing_Object_Detection.output_image_path}`
                setInfluenceImage(img)
                setTimeout(() => {
                    dispatch(handleLoader(false));
                }, 1000)
            } catch (error: any) {
                dispatch(handleLoader(false));
            }
        }
    }

    useEffect(() => {
        if (newImage) {
            setGridHeight({ name: '5' });
            setGridWidth({ name: '3' });
            setGoldenImage("");
            setInfluenceImage("");
            setGoldenImageFile("")
            setInfluenceImageFile("")
            reset();
            dispatch(setNewImage(""));
        }
        if (imageCompRadio === "grid" || imageCompRadio === "objectDetection") {
            setGridHeight({ name: '5' });
            setGridWidth({ name: '3' });
            setGoldenImage("");
            setInfluenceImage("");
            setGoldenImageFile("")
            setInfluenceImageFile("")
            reset();
            dispatch(setNewImage(""));
        }
    }, [newImage, imageCompRadio]);

    useEffect(() => {
        dispatch(setImageCompRadio('objectDetection'));
    }, [])

    return (
        <div className='content-wrapper p-4'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="compare-section">
                    <div className="compare-aside">
                        <div className='form-row'>
                            <div className='form-col'>
                                {imageCompRadio === "grid"
                                    && <>
                                        <label className="form-label">Grid 01</label>
                                        <div>
                                            <Controller
                                                name="grid_width"
                                                control={control}
                                                defaultValue={{ name: "3" }}
                                                render={({ field }) => (
                                                    <Dropdown
                                                        {...field}
                                                        id="yourDropdownId"
                                                        options={fontSizeList}
                                                        value={gridWidth}
                                                        optionLabel="name"
                                                        onChange={(e) => setGridWidth(e.target.value)}
                                                        placeholder="Select grid"
                                                        className={`bot-dropdown`}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </>
                                    // : <>
                                    //     <label className="form-label">Similarity</label>
                                    //     <div>
                                    //         <Controller
                                    //             name="request_type"
                                    //             control={control}
                                    //             render={({ field }) => (
                                    //                 <Dropdown
                                    //                     {...field}
                                    //                     id="yourDropdownId"
                                    //                     options={similarityList}
                                    //                     value={field.value}
                                    //                     optionLabel="name"
                                    //                     onChange={(e) => setValue("request_type", e.target.value, { shouldValidate: true })}
                                    //                     placeholder="Select"
                                    //                     className={`bot-dropdown`}
                                    //                 />
                                    //             )}
                                    //         />
                                    //     </div>
                                    // </>
                                }
                            </div>
                        </div>
                        <div className="container-one">
                            <div className="inner-container">
                                {goldenImage ? (
                                    <img src={`data:image/png;base64,${goldenImage}`} alt="Uploaded" className="uploaded-image" />
                                ) : (
                                    <div className="image-section">
                                        <div className="input-container"
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={handleDropBase}
                                            onDragLeave={(e) => e.preventDefault()}
                                        >
                                            <label htmlFor="fileUpload">
                                                <img src={CompareImageUpload} alt="Upload" className="upload-icon" />
                                                <p>Drop your image here, or <span>Browse</span></p>
                                            </label>
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                accept=".jpg,.png,.webp,.jpeg"
                                                onChange={handleChangeBaseImg}
                                                ref={goldImgRef}
                                            />
                                        </div>
                                        <p className="file-info"><i><img src={ImageInfo} alt="Upload" className="upload-icon" /></i>File formats: .jpg, .png with a maximum <br />file size limit of <b>5 MB</b>.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                        {errors.fileUpload && <p className="p-error mb-2">{errors.fileUpload.message as any}</p>}
                    </div>
                    <div className="compare-aside">
                        <div className={`form-row`}>
                            <div className='form-col'>
                                {imageCompRadio === "grid" &&
                                    <><label className="form-label">Grid 02</label>
                                        <div>
                                            <Controller
                                                name="grid_height"
                                                control={control}
                                                defaultValue={{ name: "5" }}
                                                render={({ field }) => (
                                                    <Dropdown
                                                        {...field}
                                                        id="yourDropdownId"
                                                        options={fontSizeList}
                                                        value={gridHeight}
                                                        optionLabel="name"
                                                        onChange={(e) => setGridHeight(e.target.value)}
                                                        placeholder="Select grid"
                                                        className={`bot-dropdown`}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        <div className={`container-one ${(imageCompRadio === "objectDetection") && "object-detection-container"}`}>
                            <div className="inner-container">
                                {influenceImage ? (
                                    <img src={influenceImage.startsWith('http') ? influenceImage : `data:image/png;base64,${influenceImage}`} alt="Uploaded" className="uploaded-image" />
                                ) : (
                                    <div className="image-section">
                                        <div className="input-container"
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={handleDropInfluence}
                                            onDragLeave={(e) => e.preventDefault()}
                                        >
                                            <label htmlFor="inferenceImage">
                                                <img src={CompareImageUpload} alt="Upload" className="upload-icon" />
                                                <p>Drop your image here, or <span>Browse</span></p>
                                            </label>
                                            <input
                                                type="file"
                                                id="inferenceImage"
                                                accept=".jpg,.png,.webp,.jpeg"
                                                onChange={handleChangeInfulenceImg}
                                                ref={influImgRef}
                                            />
                                        </div>
                                        <p className="file-info"><i><img src={ImageInfo} alt="Upload" className="upload-icon" /></i>File formats: .jpg, .png with a maximum <br />file size limit of <b>5 MB</b>.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                        {errors.inferenceImage && <p className="p-error mb-2">{errors.inferenceImage.message as any}</p>}
                    </div>
                </div>
                <div className="compare-image-action">
                    <button type="submit" className="outline-active-btn">Compare</button>
                </div>
            </form>
        </div>
    )
}

export default CompareImage;